// @flow

import React from "react";
import cx from "classnames";

import styles from "./FundingSourceTable.scss";

type TableSummaryProps = {
  summaryHeader: string,
  sum: string
};

const TableSummary = ({ summaryHeader, sum }: TableSummaryProps) => (
  <div className={cx(styles.summary, styles.normalText)} data-testid="sum">
    <span className={styles.amount}>{sum}</span>
    &nbsp;€
    <div>{summaryHeader}</div>
  </div>
);

export default TableSummary;
